export default {
  headers: {
    addTitle: 'ALTA E EMISSÃO',
    newInvoice: 'Nova fatura',
    newSelfInvoice: 'Nova autofatura',
    proForm: 'Proforma (ficará oculta)',
    import: 'Importar',
    pendingInvoices: 'Faturas não emitidas',
    pendingAutoinvoices: 'Autofaturas pendentes de emissão',
    newThirdParty: 'Novo suplido',
    pendingThirdParty: 'Suplidos não emitidos',
    searcher: 'PESQUISADOR',
    searcherOld: 'PESQUISADOR ANTIGUO',
    emittedTitle: 'EMITIDAS/RECEBIDAS',
    provider: 'Fornecedor',
    payer: 'Pagador',
    financing: 'Financiamento',
    configTitle: 'CONFIGURAÇÃO',
    generalData: 'Dados gerais',
    notification: 'Notificação',
    keys: 'Chaves',
    catalog: 'Catálogo',
    format: 'Formato de fatura',
    agenda: 'AGENDA',
    stats: 'ESTATÍSTICAS',
    thirdParty: 'Suplidos',
    thirdPartyWithoutIssued: 'Suplidos e terceiros pendentes de emissão'
  },
  summary: 'Resumo'
}